module.exports = __webpack_public_path__ + "img/account-managment-icon.d6fa4381.png";